// extracted by mini-css-extract-plugin
module.exports = {"root":"InquiryFieldError_root__1EPVJ","fieldErrors":"InquiryFieldError_fieldErrors__15Wys"};